const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the filtered content search bar directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('joinedSearch', ['TextSearch', 'Categories', '$q', '$translate', function(TextSearch, Categories, $q, $translate) {
    return {
      restrict: 'E',
      scope: {
        onQuery: '&',
        clear: '=',
        placeholder: '=',
        types: '=',
        manager: '=?',
        user: '=?',
        forReports: '=?',
        allowText: '@?'
      },
      template: require('../../templates/directives/joined-search.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.queryIds = {};
          self.queries = [];
          self.locations = {};
          self.departments = {};
          self.teams = {};
          self.org_levels = {};
          self.grades = {};

          $translate('assignmentsManager.search_assignments').then(function(translation) {
            self.placeholder = $scope.placeholder || translation;
          });

          self.getLineage = function(id, type) {
            var items = [id];
            var children = [];
            var grandChildren = [];

            var addTo = function(id) {
              children.push(id);
              var main = self[type][id];
              if (!main || !main.children || !main.children.length) {
                return;
              }
              for (var i = 0; i < main.children.length; i++) {
                grandChildren.push(main.children[i]);
              }
            };

            if (!self[type][id] || !self[type][id].children || !self[type][id].children.length) {
              return items;
            }

            for (var i = 0; i < self[type][id].children.length; i++) {
              addTo(self[type][id].children[i], children);
            }

            return items.concat(children, grandChildren);
          };

          self.updateQuery = function() {
            var item = {};

            for (var i = 0; i < self.queries.length; i++) {
              switch (self.queries[i].type) {
                case 'location':
                  var locations = self.getLineage(self.queries[i]._id, 'locations');
                  if ($scope.forReports) {
                    if (!item.locations) {
                      item.locations = [];
                    }
                    item.locations = item.locations.concat(locations);
                    break
                  }
                  item.linked_locations = '$in,' + locations.length + ',' + locations.join(',');
                  break;
                case 'department':
                  var departments = self.getLineage(self.queries[i]._id, 'departments');
                  if ($scope.forReports) {
                    if (!item.departments) {
                      item.departments = [];
                    }
                    item.departments = item.departments.concat(departments);
                    break
                  }
                  item.linked_departments = '$in,' + departments.length + ',' + departments.join(',');
                  break;
                case 'team':
                  var teams = self.getLineage(self.queries[i]._id, 'teams');
                  if ($scope.forReports) {
                    if (!item.teams) {
                      item.teams = [];
                    }
                    item.teams = item.teams.concat(teams);
                    break
                  }
                  item.linked_teams = '$in,' + teams.length + ',' + teams.join(',');
                  break;
                case 'org_level':
                  var org_levels = self.getLineage(self.queries[i]._id, 'org_levels');
                  if ($scope.forReports) {
                    if (!item.org_levels) {
                      item.org_levels = [];
                    }
                    item.org_levels = item.org_levels.concat(org_levels);
                    break
                  }
                  item.linked_org_level = '$in,' + org_levels.length + ',' + org_levels.join(',');
                  break;
                case 'grade':
                  var grades = self.getLineage(self.queries[i]._id, 'grades');
                  if ($scope.forReports) {
                    if (!item.grades) {
                      item.grades = [];
                    }
                    item.grades = item.grades.concat(grades);
                    break
                  }
                  item.linked_grade = '$in,' + grades.length + ',' + grades.join(',');
                  break;
                case 'text':
                  item.term = self.queries[i].name;
                  break;
                case 'users':
                  if ($scope.forReports) {
                    if (!item.users) {
                      item.users = [];
                    }
                    item.users.push(self.queries[i]._id);
                    break;
                  }
                  if (!item.assignee) {
                    item.assignee = [];
                  }
                  item.assignee.push(self.queries[i]._id);
                  break;
                case 'tracks':
                case 'presentations':
                case 'videos':
                case 'articles':
                case 'files':
                case 'polls':
                case 'scorm':
                case 'imported_content':
                case 'workshops':
                case 'assessments':
                case 'content':
                  if ($scope.forReports) {
                    if (!item.content) {
                      item.content = [];
                    }
                    if (!item.tracks) {
                      item.tracks = [];
                    }
                    if (self.queries[i].istrack) {
                      item.tracks.push(self.queries[i]._id);
                    }
                    item.content.push(self.queries[i]._id);
                    break;
                  }
                  item['content'] = self.queries[i]._id;
                  break;
                default:
                  break;
              }
            }
            $scope.onQuery({query: item});
          };

          self.removeUnique = function(type) {
            for (var i = 0; i < self.queries.length; i++) {
              if (self.queries[i].type === type) {
                var removed = self.queries.splice(i, 1);
                self.queryIds[removed[0]._id] = false;
                return;
              }
            }
          };

          // ------------- start ngTag triggered actions ------------
          self.addingTag = function($tag) {
            if ($tag.type && ($tag.type === 'users' || $tag.type === 'content')) {
              if ($tag.type === 'content' && !$scope.forReports) {
                self.removeUnique($tag.type);
              }
              return true;
            }
            if (Object.keys($tag).length === 1 && $tag.name && $scope.allowText && $scope.allowText === 'true') {
              $tag.text = $tag.name;
              $tag._id = $tag.name + '-text';
              $tag.type = 'text';
              self.removeUnique($tag.type);
              return true;
            }
          };

          self.addedTag = function($tag, outside) {
            self.queryIds[$tag._id] = true;
            self.updateQuery();
          };

          self.removedTag = function($tag) {
            self.queryIds[$tag._id] = false;
            self.updateQuery();
          };

          self.removeTags = function() {
            self.queries = [];
            self.updateQuery();
          };
          // ------------- End ngTag triggered actions ------------

          self.getOptions = function(input) {
            var deferred = $q.defer();

            input = input ? input.toLowerCase() : '';

            var placeholders = {
              users: {name: 'Users', text: 'Users', _id: 'users', placeholder: true},
              articles: {name: 'Articles', text: 'Articles', _id: 'articles', placeholder: true},
              files: {name: 'Files', text: 'Files', _id: 'files', placeholder: true},
              videos: {name: 'Videos', text: 'Videos', _id: 'videos', placeholder: true},
              tracks: {name: 'Tracks', text: 'Tracks', _id: 'tracks', placeholder: true},
              presentations: {name: 'Presentations', text: 'Presentations', _id: 'presentations', placeholder: true},
              polls: {name: 'Polls', text: 'Polls', _id: 'polls', placeholder: true},
              workshops: {name: 'Workshops', text: 'Workshops', _id: 'workshops', placeholder: true},
              assessments: {name: 'Assessments', text: 'Assessments', _id: 'assessments', placeholder: true},
              scorm: {name: 'Scorm', text: 'Scorm', _id: 'scorm', placeholder: true},
              imported_content: {name: 'ImportedContent', text: 'Third-Party Content', _id: 'imported_content', placeholder: true},
              locations: {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true},
              departments: {name: 'Departments', text: 'Departments', _id: 'departments', placeholder: true},
              teams: {name: 'Teams', text: 'Teams', _id: 'teams', placeholder: true},
              org_levels: {name: 'OrgLevels', text: 'OrgLevels', _id: 'org_levels', placeholder: true},
              grades: {name: 'Grades', text: 'Grades', _id: 'grades', placeholder: true},
              categories: {name: 'Categories', text: 'Categories', _id: 'categories', placeholder: true},
              journeys: {name: 'Journeys', text: 'Journeys', _id: 'journeys', placeholder: true}
            };

            var addedItems = {
              users: false,
              articles: false,
              files: false,
              videos: false,
              tracks: false,
              presentations: false,
              polls: false,
              workshops: false,
              assessments: false,
              locations: false,
              departments: false,
              teams: false,
              org_levels: false,
              grades: false,
              categories: false,
              journeys: false,
            };
            var query = {types: $scope.types.join(','), term: input};
            if ($scope.manager) {
              query.manager = $scope.manager;
            }

            TextSearch.smartSearch(query).$promise.then(function(results) {
              var items = [];

              for (var key in results) {
                if (results[key] && results[key].length && placeholders[key]) {
                  if (!addedItems[key]) {
                    items.push(placeholders[key]);
                    addedItems[key] = true;
                  }
                  var type = key !== 'users' ? 'content' : 'users';

                  results[key].forEach(function(item) {
                    var name = key === 'users' ? item.first_name + ' ' + item.last_name : item.title || item.name;
                    items.push({
                      name: name,
                      text: name,
                      _id: item._id,
                      type: type,
                      istrack: (item.name !== undefined)
                    });
                  });
                }
              }
              var types = ['locations', 'departments', 'teams', 'org_levels', 'grades'];

              types.forEach(function(type) {
                if (!self[type]) {
                  return;
                }

                for (var item in self[type]) {
                  if ($scope.optionRestrictions && $scope.optionRestrictions[type]) {
                    break;
                  }

                  if (new RegExp(input).test(self[type][item].name.toLowerCase()) && !self.queryIds[self[type][item]._id]) {

                    // Test matching segmentation lineage for restriction allotment
                    if (self.restricted && $scope.optionRestrictions[type] && $scope.optionRestrictions[type].length) {
                      var allow = false;
                      var itemLineage = self[type][item].lineage || [];
                      for (var i = 0; i < itemLineage.length; i++) {
                        if ($scope.optionRestrictions[type].indexOf(itemLineage[i]) !== -1) {
                          allow = true;
                          break;
                        }
                      }
                      if (!allow) {
                        continue;
                      }
                    }

                    if (!addedItems[type]) {
                      items.push(placeholders[type]);
                      addedItems[type] = true;
                    }

                    items.push({
                      name: self[type][item].name,
                      text: self[type][item].legacyName,
                      _id: self[type][item]._id,
                      type: type.slice(0, -1)
                    });
                  }
                }
              });
              deferred.resolve(items);
            });

            return deferred.promise;
          };
          self.legacyName = function(item, type) {
            var name = '';
            var parent;
            var parentName;
            var grandParent;
            var grandParentName;

            item.legacyName = item.name;
            item.lineage = [item._id];

            if (item.parent) {
              parent = self[type][item.parent];
              parentName = parent.name + ' -> ';
              grandParent = parent.parent;
              item.legacyName = parentName + item.name;
              item.lineage.push(parent._id);
            }

            if (grandParent) {
              grandParent = self[type][grandParent];
              grandParentName = grandParent.name + ' -> ';
              item.legacyName = grandParentName + parentName + item.name;
              item.lineage.push(grandParent._id);
            }
          };
          self.sortCategories = function(data) {
            angular.forEach(data, function(cat) {
              if (cat.location) {
                self.locations[cat._id] = cat;
              }
              if (cat.department) {
                self.departments[cat._id] = cat;
              }
              if (cat.team) {
                self.teams[cat._id] = cat;
              }
              if (cat.org_level && !($scope.hideLevel && $scope.hideLevel === true)) {
                self.org_levels[cat._id] = cat;
              }
              if (cat.grade && !($scope.hideGrade && $scope.hideGrade === true)) {
                self.grades[cat._id] = cat;
              }
            });
            for (var loc in self.locations) {
              self.legacyName(self.locations[loc], 'locations');
            }
            for (var dep in self.departments) {
              self.legacyName(self.departments[dep], 'departments');
            }
            for (var team in self.teams) {
              self.legacyName(self.teams[team], 'teams');
            }
            for (var level in self.org_levels) {
              self.legacyName(self.org_levels[level], 'org_levels');
            }
            for (var grade in self.grades) {
              self.legacyName(self.grades[grade], 'grades');
            }
          };
          self.initialize = function() {
            if ($scope.types && $scope.types.indexOf('categories') !== -1) {
              Categories.find({
                fields: ['_id', 'name', 'localized_names', 'category', 'location', 'department', 'team', 'org_level', 'grade', 'company', 'level', 'parent', 'children'].join(','),
                $or: '10,location,true,department,true,team,true,org_level,true,grade,true',
                sort: 'name,1'
              }).$promise.then(function(data) {
                self.sortCategories(data);
              });
            }
          };

          self.initialize();

          $scope.$watch('clear', function(newVal, oldVal) {
            if (newVal && !oldVal) {
              self.removeTags();
              $scope.clear = false;
            }
          });
        }],
      controllerAs: 'search'
    };
  }]);